import { useEffect } from "react";

export default function useNomeArquivoPdf(codigo) {
  useEffect(() => {
    const nomeArquivo = String(codigo || "").trim();
    if (!nomeArquivo || nomeArquivo === "-") return undefined;

    const tituloAnterior = document.title;
    document.title = nomeArquivo;

    return () => {
      document.title = tituloAnterior;
    };
  }, [codigo]);
}
